import { render, staticRenderFns } from "./solicitudVehiculosAprob2.vue?vue&type=template&id=585a357e&scoped=true"
import script from "./solicitudVehiculosAprob2.vue?vue&type=script&lang=js"
export * from "./solicitudVehiculosAprob2.vue?vue&type=script&lang=js"
import style0 from "./solicitudVehiculosAprob2.vue?vue&type=style&index=0&id=585a357e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a357e",
  null
  
)

export default component.exports